// extracted by mini-css-extract-plugin
export var dropdownButton = "_17-0";
export var fullWidthDropdownButton = "_17-1";
export var icon = "_17-3";
export var iconPlaceholder = "_17-2";
export var menuItemRow = "_17-5";
export var shortcutContainer = "_17-4";